import React from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useLocation } from 'react-router';
import CustomLink from '@/components/CustomLink';
import styles from './styles';

type SidebarMenuItem = {
  path: string;
  label: string;
  icon: React.ReactNode;
};

type SidebarMenuProps = {
  items: SidebarMenuItem[];
};

const SidebarMenu = ({ items }: SidebarMenuProps) => {
  const location = useLocation();

  return (
    <List sx={styles.list}>
      {items.map((item, index) => {
        const isActive =
          location.pathname === item.path ||
          (!items.some((i) => i.path === location.pathname) && index === 0);

        return (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={CustomLink}
              to={item.path}
              sx={styles.listItemButton}
              selected={isActive}
              aria-current={isActive ? 'page' : undefined}
            >
              <ListItemIcon sx={styles.listItemIcon}>{item.icon}</ListItemIcon>
              <ListItemText sx={styles.text} primary={item.label} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default SidebarMenu;
